document.addEventListener("variant:add", async (event) => {

  const form = event.target;

  const selected = form.querySelector(
    'input[name="properties[Drainage Hole]"]:checked'
  );

  if (!selected) return;

  const variantId = selected.dataset.variantId;

  if (!variantId) return;

  const quantity =
    parseInt(form.querySelector('input[name="quantity"]').value, 10) || 1;

  await fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      items: [{
        id: variantId,
        quantity: quantity
      }]
    })
  });

  document.dispatchEvent(new CustomEvent("cart:refresh"));

});